import { call, put, takeLatest, select } from "redux-saga/effects"
import {
  FETCH_PRODUCTION_ORDERS,
  FETCH_PRODUCTION_TASKS,
  UPDATE_ORDER_STATUS,
  BULK_UPDATE_ORDERS,
} from "./actionTypes"
import {
  fetchProductionOrdersSuccess,
  fetchProductionOrdersFail,
  fetchProductionTasksSuccess,
  fetchProductionTasksFail,
  updateOrderStatusSuccess,
  updateOrderStatusFail,
  bulkUpdateOrdersSuccess,
  bulkUpdateOrdersFail,
} from "./actions"
import { selectIsCacheValid, selectTasksCacheValid } from "./reducer"
import { getOrders, getTasks, patchOrder } from "helpers/api_helper"

function* fetchOrdersSaga(action) {
  try {
    const { forceRefresh } = action.payload
    const cacheValid = yield select(selectIsCacheValid)

    if (cacheValid && !forceRefresh) {
      return
    }

    const orders = yield call(getOrders, true)
    yield put(fetchProductionOrdersSuccess(orders || []))
  } catch (error) {
    yield put(fetchProductionOrdersFail(error.message))
  }
}

function* fetchTasksSaga(action) {
  try {
    const { forceRefresh } = action.payload
    const cacheValid = yield select(selectTasksCacheValid)

    if (cacheValid && !forceRefresh) {
      return
    }

    const tasks = yield call(getTasks)
    yield put(fetchProductionTasksSuccess(tasks || []))
  } catch (error) {
    yield put(fetchProductionTasksFail(error.message))
  }
}

function* updateOrderStatusSaga(action) {
  try {
    const { orderId, status, extraData } = action.payload
    const payload = {
      resource: [{ id: orderId, status, ...extraData }],
    }
    yield call(patchOrder, payload)
    yield put(updateOrderStatusSuccess({ id: orderId, status, ...extraData }))
  } catch (error) {
    yield put(updateOrderStatusFail(error.message))
  }
}

function* bulkUpdateOrdersSaga(action) {
  try {
    const { orderIds, status } = action.payload
    const payload = {
      resource: orderIds.map((id) => ({ id, status })),
    }
    yield call(patchOrder, payload)
    yield put(
      bulkUpdateOrdersSuccess(orderIds.map((id) => ({ id, status })))
    )
  } catch (error) {
    yield put(bulkUpdateOrdersFail(error.message))
  }
}

function* productionSaga() {
  yield takeLatest(FETCH_PRODUCTION_ORDERS, fetchOrdersSaga)
  yield takeLatest(FETCH_PRODUCTION_TASKS, fetchTasksSaga)
  yield takeLatest(UPDATE_ORDER_STATUS, updateOrderStatusSaga)
  yield takeLatest(BULK_UPDATE_ORDERS, bulkUpdateOrdersSaga)
}

export default productionSaga
